// Chart titles are suggested as "<base> — <PatientName>" (see PatientDashboard's
// auto-title effect) so a chart stays identifiable outside the patient's context
// — e.g. in the patient's own mobile app list. Inside a patient's dashboard the
// therapist has already selected that patient, so the trailing name is redundant.
// Strip it for DISPLAY ONLY; the stored title keeps the name (storage untouched).
export function stripClientName(title: string, patientName?: string): string {
  const name = (patientName || "").trim();
  const t = (title || "").trimEnd();
  if (!t || !name) return title;
  // Auto-title joins with " — " (em dash); tolerate en-dash/hyphen if a title
  // was hand-edited. Only strip when the name is the exact trailing segment.
  for (const sep of [" — ", " – ", " - "]) {
    const suffix = sep + name;
    if (t.endsWith(suffix)) return t.slice(0, -suffix.length).trimEnd();
  }
  return title;
}
